import { useState } from 'react'
import { useHistory } from 'react-router'
import Card from '@material-ui/core/Card'
import Chip from '@material-ui/core/Chip'
import { ROLES } from '../../../config/user'
import EditIcon from '@material-ui/icons/Edit'
import { IconButton } from '@material-ui/core'
import CopyIcon from '@material-ui/icons/FileCopy'
import { ITemplate } from '../../../types/templates'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { moneyFormat } from '../../../utils/functions'
import CardContent from '@material-ui/core/CardContent'
import { saveTemplate } from '../../../services/templates'
import { useSession } from '../../../context/SessionContext'
import DialogConfirm from '../../../components/DialogConfirm'
import Alert, { ActionsOptType } from '../../../components/Alert'
// import { CardActions, IconButton } from '@material-ui/core'

/**
 * define styles for the component
*/
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: '14rem',
    maxHeight: '14rem', 
    border: '1.5px solid #d3d4d5',
    "&:hover":{
      transform: 'scale(1.05)',
      transition: '0.3s',
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.06)"
    },
  },
  title: {
    marginTop:'3vh',
    lineHeight: 1.2,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    fontSize: '1.1rem',
  },
  description: {
    whiteSpace: 'pre-line',
    marginTop: '1.5vh',
    textAlign: 'justify',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1vh',
  },
})

/**
 * This method is used to define style for each item and add functionality 
 * @param {Itemplate} template 
 * @return TemplateItem
 */
const TemplateItem = ({ template }: { template: ITemplate }): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useSession()
  const [open, setOpen] = useState(false)
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to generate a copy
   * @return {Void}
   */
  const copyTemplate = async () => {
    const { data, error } = await saveTemplate({
      name: template.name,
      description: template.description,
      template_status_id: template.template_status_id,
      template_type_id: template.template_type_id,
      template_data: template.template_data,
    })
    if (data) {
      setAlertOptions({
        message: `Se ha generado una copia de ${template.name}`,
        open: true,
        type: 'info',
      })
      history.push('/docengine')
    }
    if (error) {
      setAlertOptions({ message: error, open: true, type: 'error' })
    }
    setOpen(false)
  }

  return (
    <Card
      className={classes.root}
      style={{cursor:'pointer'}}
      onClick={() => {
        if (user?.role === ROLES.USER)
          history.push({ pathname: '/docengine/editor', state: template })
      }}
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <CardContent>
        <Typography
          gutterBottom
          variant="h6"
          component="h5"
          className={classes.title}
        >
          {template.name}
        </Typography>
        <Typography
          className={classes.description}
          variant="body2"
          color="textSecondary"
          component="p"
        >
          {template.description}
        </Typography>
        {user?.role === ROLES.ADMIN && (
          <div className={classes.actions}>
            <IconButton
              aria-label="Editar"
              onClick={() => {
                history.push({ pathname: '/docengine/editor', state: template })
              }}
            >
              <EditIcon />
            </IconButton>
            <DialogConfirm
              open={open}
              setOpen={setOpen}
              title={'GENERAR COPIA'}
              description={`Confirma que desea crear una copia de ${template.name}`}
              confirmFx={copyTemplate}
            />
            <IconButton
              aria-label="Crear copia"
              onClick={() => {
                setOpen(true)
              }}
            >
              <CopyIcon />
            </IconButton>
          </div>
        )}
        {user?.role === ROLES.USER && (
          <div className={classes.priceContainer}>
            <Chip
              label={`${template.price ? moneyFormat(template.price) : '¡GRATIS!'}`}
              style={{
                backgroundColor: '#0EBE49',
                color: 'white',
              }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default TemplateItem